export default "__VITE_ASSET__BViTu$rF__"